import * as types from "./types";

export const enviarDocumentos = (data) => ({
  payload: data,
  type: types.ENVIAR_DOCUMENTOS
});

export const documentosEnviados = (payload) => ({
  payload,
  type: types.DOCUMENTOS_ENVIADOS
});

export const errorEnviandoDocumentos = (error) => ({
  error: error,
  type: types.ERROR_DOCUMENTOS_ENVIADOS
});

export const limpiarEstadoEnviarDocumentos = () => ({
  type: types.LIMPIAR_ENVIO_DOCUMENTOS
});
